import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { firstCapital } from 'src/app/lib/capital';
import { dateHours, dateHoursClose, dateHourswithTime, dateTimeFormat } from 'src/app/lib/dateFilter';
import isEmpty from 'src/app/lib/isEmpty';
import { toFixed, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';

@Component({
  selector: 'app-adminBotdetails',
  templateUrl: './adminBotdetails.component.html',
  styleUrls: ['./adminBotdetails.component.css'],
  animations: [
    trigger('contentAnimation', [

      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('.5s ease-out', style({ height: '*', opacity: 1 }))
      ]),

      transition(':leave', [
        animate('.15s ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class adminBotdetailsComponent {
  @Input() botDetails: any
  @Input() orderStep: any
  @Output() gotoStep = new EventEmitter<any>();
  constructor(
    private router: Router,
    private toastr: ToastrService,
  ) {

  }


  toFixedDown = toFixedDown
  toFixed = toFixed
  parseFloat = parseFloat
  isEmpty = isEmpty
  dateTimeFormat = dateTimeFormat
  firstCapital = firstCapital
  dateHoursClose = dateHoursClose
  truncateDecimals = truncateDecimals
  isCollapsed = true;
  showCancel = false
  showBack = false
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  getNow(): Date {
    return new Date();
  }
  navigateToOrders() {
    this.router.navigateByUrl('signin')
  }

  botCancel() {
    this.toggleCollapse()
    this.showCancel = true
    setTimeout(() => {
      this.orderStep = 'four';
    });
  }
  CopyText(value: any) {
    navigator.clipboard.writeText(value);
    this.toastr.success('Copied...');
  }
  maskId(id?: string): string {
    if (!id) return '.....'; // placeholder if undefined
    return id.slice(0, 6) + '.....' + id.slice(-4);
  }

  goToPage() {
    this.gotoStep.emit("one")
    this.showBack = true
  }
}
